import { createApi } from "@reduxjs/toolkit/query/react";
import { CreateDeployList, DeployList, GetDeployList, UpdateDeployList } from "@shared/models";
import { axiosBaseQuery } from "@shared/utils/request";

import config from "../../config";

export const deployListsApi = createApi({
  reducerPath: "deployListsApi",
  baseQuery: axiosBaseQuery({
    baseUrl: `${config.baseApiUrl}deploy-list`,
  }),
  tagTypes: ["DeployList", "DeployLists"],
  endpoints: (builder) => ({
    getDeployLists: builder.query<DeployList[], GetDeployList>({
      providesTags: ["DeployLists"],
      query: (params) => ({ url: "", params }),
    }),
    getDeployList: builder.query<DeployList, number | string | undefined>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: (result, error, id) => [{ type: "DeployList", id }],
    }),
    createDeployList: builder.mutation<DeployList, CreateDeployList>({
      query: (body) => ({
        url: ``,
        method: "POST",
        body,
      }),
      invalidatesTags: ["DeployLists"],
    }),
    updateDeployList: builder.mutation<DeployList, UpdateDeployList>({
      query: ({ id, ...body }) => ({
        url: `/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "DeployList", id }, { type: "DeployLists" }],
    }),
    deleteDeployList: builder.mutation<DeployList, DeployList>({
      query: ({ id }) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      onQueryStarted: async ({ id, account_id }, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;

          dispatch(
            deployListsApi.util.updateQueryData("getDeployLists", { account_id }, (draft) => {
              return draft.filter((item) => item.id !== id);
            }),
          );

          dispatch(
            deployListsApi.util.updateQueryData("getDeployList", id, () => {
              return undefined;
            }),
          );
        } catch {
          console.error("Failed to update cache on deleteDeployList");
        }
      },
    }),
  }),
});

export const {
  useGetDeployListsQuery,
  useGetDeployListQuery,
  useCreateDeployListMutation,
  useUpdateDeployListMutation,
} = deployListsApi;
